export function sanitizeMjcfName(name) {
  if (typeof name !== "string") return "";
  const trimmed = name.trim();
  // Empty / whitespace-only inputs are not MJCF identifiers; callers use "" to mean "prefer fallback".
  if (!trimmed) return "";
  // Replace whitespace with underscores
  let out = trimmed.replace(/\s+/g, "_");
  // Allow letters, digits, underscore, slash, dot, hyphen, colon; replace others with underscore
  out = out.replace(/[^A-Za-z0-9_/.\-:]/g, "_");
  // MuJoCo names must start with a letter or underscore; only prepend when there is substantive content.
  if (out && !/^[A-Za-z_]/.test(out)) out = "b_" + out;
  return out;
}
